import React from 'react';
import { __ } from 'i18n/index';
import store from 'react/redux/store/store';
import { UserComponent } from 'react/UserComponent';
import { plainRoomLinkText } from 'components/MessageParser';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';
import { isPhoneWidth } from 'react/dock/phoneWidth';
import { visit } from 'navigation/clientNavigation';

// The toast for a mention in a room (models/ChatMessages addUnreadMessage):
// who, where and the message, with Reply. Reply starts an @reply to the
// sender: off the netplay page in the dock's chat sheet, scrolled to the
// message (react/dock/chat); on the netplay page in the room itself. Phones
// have no sheet and go to the room. The room's name is a chat link: it opens
// the room in place on the netplay page, and in the Chat view elsewhere.
export default function MentionToast({ chatRoom, message, onDone }) {
	const reply = () => {
		if(isNetplayPageActive()) {
			chatRoom.setActive();
			// The room's composer mounts once it is the selected room.
			setTimeout(() => chatRoom.chatMessages.addMention(message.player), 0);
		}
		else if(isPhoneWidth()) {
			visit(chatRoom.getUrl());
		}
		else {
			// Loaded on use: models/ChatMessages, which shows this toast, is below the dock in the import graph.
			import(/* webpackChunkName: "dock-chat-open" */ 'react/dock/chat/openDockChat').then(({ default: openDockChat }) => {
				store.dispatch(openDockChat({ conversation: { kind: 'room', id: chatRoom.id }, messageId: message.id }));
			});
		}
		onDone();
	};

	return (
		<span className='mention-toast'>
			<span>
				<UserComponent user={message.player} />{' '}{__('mentioned you in')}{' '}
				<a className='chatlink' data-id={chatRoom.id} href={chatRoom.getUrl()}>{chatRoom.name}</a>
			</span>
			<span className='mention-toast__quote'>{plainRoomLinkText(message.message, message.linkedRooms)}</span>
			<span className='mention-toast__actions'>
				<button type='button' className='mention-toast__reply' onClick={reply}>{__('Reply')}</button>
			</span>
		</span>
	);
}
